/**
 * Contact service — resolves the caller's contact graph.
 *
 * GET /api/v1/users/me/contacts (API_ENDPOINTS.usersContacts) — returns users
 * the caller has a direct relationship with (accepted invite, shareable-link
 * acceptance, or shared transaction), each carrying a `roles` array and,
 * for AGENT contacts, a `licenseState`. Mirrors mobile's contact.service.ts
 * contactService.getContacts().
 */
import { apiClient, API_ENDPOINTS } from '../config/api';

export const contactService = {
  getContacts: async (firebaseToken, page = 0, size = 20, viewingRole, query) => {
    const params = {
      page,
      size,
      ...(viewingRole && { viewingRole }),
      ...(query && query.trim().length > 0 && { query: query.trim() }),
    };
    const response = await apiClient.get(API_ENDPOINTS.usersContacts, {
      headers: { Authorization: `Bearer ${firebaseToken}` },
      params,
    });
    const data = response.data;
    return Array.isArray(data) ? { content: data } : (data || { content: [] });
  },

  /**
   * POST /api/v1/users/me/contacts — add an already-registered user as a
   * contact by email. Mirrors mobile's contactService.addContactByEmail.
   * Server responses:
   *   201 { …ContactResponse } — added; caller should refresh the list
   *   404 — no platform user has that email (UX: suggest inviting them)
   *   409 — already a contact of the caller
   * Callers catch and read `err.response.status` to branch the copy.
   */
  addContactByEmail: async (firebaseToken, email) => {
    const response = await apiClient.post(
      API_ENDPOINTS.usersContacts,
      { email },
      { headers: { Authorization: `Bearer ${firebaseToken}` } },
    );
    return response.data;
  },
};
